<template>
    <div class="fixed top-0 left-0 right-0 bottom-0 z-[100] w-screen h-screen flex flex-col justify-center items-center bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm transition-colors duration-300">
        <div class="w-full max-w-md p-4 flex flex-col items-center gap-6">
            <input v-model="name" type="text" placeholder="Playlist name" class="w-full text-center text-2xl p-2 bg-transparent border-0 border-b-2 border-indigo-500 focus:ring-0 focus:border-indigo-600 outline-none placeholder:text-slate-400 dark:text-white" @keyup.enter="create">
            <div class="flex gap-4">
                <button @click="create" class="px-6 py-2 bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white rounded-md shadow-lg transition-transform hover:scale-105">Create</button>
                <button @click="cancel" class="px-6 py-2 bg-gradient-to-r from-slate-500 to-slate-600 hover:from-slate-600 hover:to-slate-700 text-white rounded-md shadow-lg transition-transform hover:scale-105">Cancel</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import playlistService from '@/service/playlist.service.js';
import toastStore from '@/store/toast.store';
const router = useRouter();
const name = ref('');
const isSubmitting = ref(false);

const cancel = () => {
    router.back();
};

const create = async () => {
    if (!name.value) {
        toastStore.dispatch('addMessage', {
            message: 'Playlist name is required',
            icon: 'error',
            ttl: 3000,
            classes: 'z-[1000]'
        })
        return;
    }
    if (isSubmitting.value) return;
    isSubmitting.value = true;
    try {
        const response = await playlistService.create({ name: name.value });
        const data = await response.json().catch(() => ({}));

        const playlistId = data?._id || data?.id;
        if (response.ok && playlistId) {
            toastStore.dispatch('addMessage', {
                message: `Playlist '${name.value}' created successfully. Redirecting to editor...`,
                icon: 'success',
                ttl: 3000,
                classes: 'z-[1000]'
            });
            router.push({ name: 'Playlist Editor', params: { id: playlistId } });
            return;
        }

        if (response.status === 409 || data?.status === 409) {
            toastStore.dispatch('addMessage', {
                message: `Playlist '${name.value}' already exists`,
                icon: 'error',
                ttl: 3000,
                classes: 'z-[1000]'
            });
            return;
        }

        if (response.status === 403 || data?.error === 'LIMIT_REACHED' || data?.message === 'LIMIT_REACHED') {
            toastStore.dispatch('addMessage', {
                message: `Playlist limit reached. Upgrade your plan to create more playlists.`,
                icon: 'error',
                ttl: 4000,
                classes: 'z-[1000]'
            });
            return;
        }

        toastStore.dispatch('addMessage', {
            message: data?.message || `Error creating playlist '${name.value}'`,
            icon: 'error',
            ttl: 3000,
            classes: 'z-[1000]'
        });
    } catch (e) {
        console.error(e);
        toastStore.dispatch('addMessage', {
            message: `Error creating playlist '${name.value}'`,
            icon: 'error',
            ttl: 3000,
            classes: 'z-[1000]'
        });
    } finally {
        isSubmitting.value = false;
    }
};
</script>